import * as React from "react";
const Gift = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={60}
    height={60}
    viewBox="0 0 60 60"
    fill="none"
    {...props}
  >
    <path
      d="M60 30.0003C60 46.5684 46.5684 60 29.9997 60C13.4313 60 0 46.5684 0 30.0003C0 13.4316 13.4313 0 29.9997 0C46.5684 0 60 13.4316 60 30.0003Z"
      fill="black"
      fillOpacity={0.05}
    />
    <mask
      id="mask0_1144_106663"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={60}
      height={60}
    >
      <path
        d="M60 30.0003C60 46.5684 46.5684 60 29.9997 60C13.4313 60 0 46.5684 0 30.0003C0 13.4316 13.4313 0 29.9997 0C46.5684 0 60 13.4316 60 30.0003Z"
        fill="#8A02D2"
      />
    </mask>
    <g mask="url(#mask0_1144_106663)">
      <path
        d="M17.3657 62.9829H7.45898C7.45898 62.9829 7.79929 53.444 7.73291 44.8072C7.66456 38.9731 7.45898 33.7793 7.45898 33.7793H17.3657V62.9829Z"
        fill="#D14A2A"
      />
      <path
        d="M46.9487 62.9829H17.2285V33.7793H46.9487C46.9487 33.7793 46.5896 41.5021 46.7555 44.268C46.9215 47.0339 46.9487 62.9829 46.9487 62.9829Z"
        fill="#DD836D"
      />
      <path
        d="M29.1992 62.9829H36.3541V33.7793H29.1992V62.9829Z"
        fill="white"
      />
      <mask
        id="mask1_1144_106663"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={14}
        y={33}
        width={7}
        height={5}
      >
        <path
          d="M20.5954 33.8887H14.1865V37.6703H20.5954V33.8887Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_1144_106663)">
        <path
          d="M16.7316 33.8132L14.5098 34.4308L16.7905 34.9624L17.3816 37.0672L18.0179 34.9592L20.084 34.4175L17.9358 33.8102L17.3943 31.584L16.7316 33.8132Z"
          fill="white"
        />
      </g>
      <path
        d="M42.4043 46.7441L41.5 49.6194C41.2505 50.4128 45.1351 52.3412 50.1772 53.9269C55.2187 55.5125 59.5084 56.1549 59.7579 55.3615L60.6622 52.4862L42.4043 46.7441Z"
        fill="#D14A2A"
      />
      <path
        d="M60.6616 52.4871C60.4121 53.2805 56.1227 52.6382 51.0809 51.0525C46.0391 49.4669 42.1542 47.5385 42.4037 46.7451C42.6532 45.9517 46.9426 46.594 51.9844 48.1796C57.0262 49.7652 60.9111 51.6937 60.6616 52.4871Z"
        fill="#D14A2A"
      />
      <path
        d="M50.1973 50.7773L49.2952 53.6455L51.5095 54.3326L52.4089 51.4729L50.1973 50.7773Z"
        fill="#DFD9D2"
      />
      <path
        d="M49.2441 50.4766L48.3492 53.3223L49.0424 53.5603L49.9431 50.6964L49.2441 50.4766Z"
        fill="#DFD9D2"
      />
      <path
        d="M44.2129 40.0059L42.9027 42.7204C42.5412 43.4694 46.1064 45.9387 50.8665 48.2363C55.6261 50.5336 59.7779 51.789 60.1394 51.0399L61.4496 48.3254L44.2129 40.0059Z"
        fill="#D14A2A"
      />
      <path
        d="M61.4494 48.3261C61.0878 49.0751 56.9363 47.8198 52.1764 45.5224C47.4166 43.225 43.8511 40.7555 44.2126 40.0065C44.5742 39.2575 48.7257 40.5128 53.4856 42.8102C58.2454 45.1076 61.8109 47.5771 61.4494 48.3261Z"
        fill="#D14A2A"
      />
      <path
        d="M51.3418 45.1191L50.0349 47.8269L52.1266 48.8267L53.4297 46.1269L51.3418 45.1191Z"
        fill="#DFD9D2"
      />
      <path
        d="M50.4424 44.6855L49.1457 47.3721L49.7972 47.7078L51.1023 45.004L50.4424 44.6855Z"
        fill="#DFD9D2"
      />
      <path
        d="M8.37496 27.8202C9.73636 27.8202 10.8398 26.7168 10.8398 25.3554C10.8398 23.994 9.73636 22.8906 8.37496 22.8906C7.01384 22.8906 5.91016 23.994 5.91016 25.3554C5.91016 26.7168 7.01384 27.8202 8.37496 27.8202Z"
        stroke="#D14A2A"
        strokeWidth={1.0648}
        strokeMiterlimit={10}
      />
      <path
        d="M25.287 5.64007C24.5473 7.6874 24.8004 8.87656 26.0457 9.20782C27.291 9.53908 27.5247 10.5656 26.7469 12.2871"
        stroke="#D14A2A"
        strokeWidth={1.0648}
        strokeMiterlimit={10}
      />
      <path
        d="M55.189 28.3046C55.189 29.0195 54.6092 29.5991 53.8941 29.5991C53.1794 29.5991 52.5998 29.0196 52.5998 28.3046C52.5998 27.5895 53.1794 27.01 53.8941 27.01C54.6092 27.01 55.189 27.5896 55.189 28.3046Z"
        fill="white"
        stroke="#D14A2A"
        strokeWidth={0.273868}
      />
      <path
        d="M29.9789 33.1949C29.9789 33.1949 22.4046 31.6502 22.9137 26.616C23.4226 21.5814 27.9851 23.0194 27.9851 23.0194C27.9851 23.0194 33.1261 24.2479 29.9789 33.1949Z"
        stroke="#694B3F"
        strokeWidth={2.18228}
        strokeMiterlimit={10}
      />
      <path
        d="M30.7235 33.2693C30.5368 33.3688 30.3116 33.2361 30.3126 33.0272C30.3229 30.7255 30.8436 20.8599 35.8462 18.1817C40.8028 15.9734 43.0713 19.7806 43.4404 20.7921C43.81 21.8035 44.6273 26.0389 37.99 29.4762C33.3543 31.8772 31.4503 32.8817 30.7235 33.2693Z"
        stroke="#694B3F"
        strokeWidth={2.18228}
        strokeMiterlimit={10}
      />
      <path
        d="M28.9189 32.6833L29.8326 32.7437L22.3201 50.9468L21.7297 48.3085L18.7823 49.1073L28.9189 32.6833Z"
        fill="#694B3F"
      />
      <path
        d="M28.8545 32.9531L30.7572 32.6277L40.053 39.4057L36.1599 38.9001L35.8252 41.6419L28.8545 32.9531Z"
        fill="#694B3F"
      />
    </g>
  </svg>
);
export default Gift;
